// ⚠️ AVTOMATIK KO'CHIRILGAN NUSXA — QO'L BILAN TAHRIRLAMANG.
// Manba: frontend/shared/format/format.intl.ts
// Yangilash: panel papkasidan `node ../shared/sync.mjs`
// Qorovul: `npm run test:format` (uchala panelda) — nusxa manbadan
// bir bayt farq qilsa yiqiladi.
// `Intl` formatlagichlari keshi — `format.units.ts` va `format.money.ts`
// ikkalasi ham ishlatadi, shuning uchun alohida modul.
//
// ⚠️ BU ICHKI YORDAMCHI. Panelning `format.ts` barreli uni QAYTA EKSPORT
// QILMAYDI: `numberFormat` sahifalarda emas, faqat shu papkada ishlatilsin.
//
// NEGA KESH: `new Intl.NumberFormat(...)` har chaqiruvda ICU ma'lumotini
// qayta o'qiydi. Jadvalda 500 qator × 4 ustun = 2000 chaqiruv, ya'ni bu
// o'lchanadigan sekinlik.

const numberFormatCache = new Map<string, Intl.NumberFormat>()

/** Locale + parametrlar bo'yicha keshlangan `Intl.NumberFormat` */
export function numberFormat(
  locale: string,
  options: Intl.NumberFormatOptions,
): Intl.NumberFormat {
  const key = `${locale}|${JSON.stringify(options)}`
  let fmt = numberFormatCache.get(key)
  if (!fmt) {
    fmt = new Intl.NumberFormat(locale, options)
    numberFormatCache.set(key, fmt)
  }
  return fmt
}
